import { Controller } from 'stimulus';

export default class extends Controller {
  busy(event) {
    if (event.detail.formSubmission.submitter !== this.element) {
      return;
    }
    this.element.setAttribute('aria-busy', 'true');
  }

  idle(event) {
    if (event.detail.formSubmission.submitter !== this.element) {
      return;
    }
    this.element.removeAttribute('aria-busy');
  }
}
